import React, { useState, useEffect } from "react";
import { FiEye, FiEyeOff, FiCopy, FiRefreshCcw } from "react-icons/fi";

import { fetchChaveSecreta } from "../../integration/chave_secreta/fetchChaveSecreta";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ChavesSection = () => {
  const [daraResp, setDaraResp] = useState("");

  async function funcChave() {
    try {
      const resp = await fetchChaveSecreta();
      setDaraResp(resp);
    } catch (error) {
      console.error("Erro ao atualizar a chave.");
    }
  }

  useEffect(() => {
    funcChave();
  }, []);

  const [chavePrivadaVisivel, setChavePrivadaVisivel] = useState(false);

  // Substitua pelas suas chaves reais ou obtenha dinamicamente
  const chavePublica = "";
  const chavePrivada = daraResp.privateKey || "";

  const copiarParaClipboard = (texto) => {
    navigator.clipboard.writeText(texto);
    alert("Copiado para a área de transferência!");
  };

  return (
    <div className="max-w-xl mx-auto bg-white border border-gray-200 p-6 rounded-xl shadow">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h2 className="text-2xl font-light text-[#0c0c0c] text-center ">
          Suas Chaves
        </h2>
      </div>

      {/* Descrição */}
      <p className="text-sm text-gray-600 mb-6">
        Aqui estão suas chaves de API, que permitem acesso aos recursos da nossa
        plataforma.{" "}
        <a
          href="https://medusa-payments.readme.io/reference/introdu%C3%A7%C3%A3o"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:underline"
        >
          Consulte nossa documentação para mais informações.
        </a>
      </p>

      {/* Chave Privada */}
      <div>
        <label className="text-sm text-gray-600 block mb-1">
          Chave Privada:
        </label>
        <div className="flex items-center gap-2">
          <div className="bg-gray-100 px-3 py-2 rounded-md text-sm text-gray-800 w-full truncate flex items-center">
            {chavePrivadaVisivel
              ? chavePrivada
              : "*".repeat(chavePrivada.length)}

            {!chavePrivadaVisivel && chavePrivada === "" && (
              <FiRefreshCcw className="animate-spin text-gray-500 ml-2" />
            )}
          </div>

          {chavePrivada && (
            <>
              <button
                onClick={() => setChavePrivadaVisivel((visivel) => !visivel)}
                className="text-gray-600 hover:text-black"
              >
                {chavePrivadaVisivel ? (
                  <FiEyeOff className="w-5 h-5" />
                ) : (
                  <FiEye className="w-5 h-5" />
                )}
              </button>
              <button
                onClick={() => copiarParaClipboard(chavePrivada)}
                className="text-gray-600 hover:text-black"
              >
                <FiCopy className="w-5 h-5" />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChavesSection;
